import React from 'react';
import LandingNavbar from '../components/landing/LandingNavbar';
import HeroSection from '../components/landing/HeroSection';
import StepsSection from '../components/landing/StepsSection';
import ManagementSection from '../components/landing/ManagementSection';
import TechSection from '../components/landing/TechSection';
import CTASection from '../components/landing/CTASection';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen">
      <LandingNavbar />
      <HeroSection />
      <StepsSection />
      <ManagementSection />
      <TechSection />
      <CTASection />
      <footer style={{ background: '#0f172a' }} className="py-10">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <div
              className="w-7 h-7 rounded-xl flex items-center justify-center"
              style={{ background: 'linear-gradient(135deg, #3b82f6, #06b6d4)' }}
            >
              <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
              </svg>
            </div>
            <span className="text-slate-300 font-semibold text-sm">智能标书助手</span>
          </div>
          <p className="text-slate-500 text-sm">
            © 2024 智能标书助手 · AI 驱动的标书编写平台
          </p>
          <p className="text-slate-600 text-xs">
            v2.0.0 · Powered by LLM-Todo
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
